import type { RouteObject } from 'react-router-dom';

/**
 * Views 18 to 23 (§4.7 / §7.2 of the screen inventory). 21, 22 and 23 are TABS
 * of the detail (19), not pages: they live in `features/companies/` and mount
 * as child routes of `companies/:id`, so `CompanyDetailPage` renders them
 * through `<Outlet />` inside `Tabs` (`Tabs` never navigates on its own — this
 * screen writes the route). 20 (`PromoteDialog`) is an action inside 19, with
 * no route of its own.
 *
 * `companies/new` reuses `CompanyDetailPage` (creation mode, `POST
 * /api/companies`, no `:id`): the brief treats it as the SAME screen ("detail /
 * edit"), not a separate view. It is declared BEFORE `companies/:id` — react
 * router v6 does not require that to avoid clashing with the dynamic segment,
 * but putting it first documents the intent without relying on that guarantee.
 */
export const companiesRoutes: RouteObject[] = [
  {
    path: 'companies',
    lazy: () =>
      import('../pages/CompaniesListPage').then((m) => ({
        Component: m.CompaniesListPage,
      })),
  },
  {
    path: 'companies/new',
    lazy: () =>
      import('../pages/CompanyDetailPage').then((m) => ({
        Component: m.CompanyDetailPage,
      })),
  },
  {
    path: 'companies/:id',
    lazy: () =>
      import('../pages/CompanyDetailPage').then((m) => ({
        Component: m.CompanyDetailPage,
      })),
    children: [
      {
        path: 'certificates',
        lazy: () =>
          import('@/features/companies/CertificatesTab').then((m) => ({
            Component: m.CertificatesTab,
          })),
      },
      {
        path: 'cafs',
        lazy: () =>
          import('@/features/companies/CafsTab').then((m) => ({
            Component: m.CafsTab,
          })),
      },
      {
        path: 'users',
        lazy: () =>
          import('@/features/companies/CompanyUsersTab').then((m) => ({
            Component: m.CompanyUsersTab,
          })),
      },
      {
        path: 'sii',
        lazy: () =>
          import('@/features/companies/SiiCredentialsTab').then((m) => ({
            Component: m.SiiCredentialsTab,
          })),
      },
    ],
  },
];
